import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }

        return failureCount < 3;
      },
      retryDelay: (failureCount) => {
        // Exponential backoff with a random jitter
        const baseDelay = Math.min(1000 * 2 ** failureCount, 30000); // Max 30 seconds
        const randomJitter = Math.random() * 500; // Add up to 500ms random delay

        return baseDelay + randomJitter;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

export { queryClient };
